export const GET_PENDING_OTHER_ERROR = 'GET_PENDING_OTHER_ERROR';
export const GET_PENDING_OTHER_START = 'GET_PENDING_OTHER_START';
export const GET_PENDING_OTHER_SUCCESS = 'GET_PENDING_OTHER_SUCCESS';
